import { gql } from '@apollo/client';

/** flag-service federated Organization fields via org gateway `fetchOrganization`. */
export const FETCH_ORGANIZATION_FLAG_POLICIES = gql`
  query fetchOrganizationFlagPolicies($organizationId: String!) {
    fetchOrganization(organizationId: $organizationId) {
      organization {
        id
        flagAmountThresholds {
          flagType
          thresholdCents
          percentThreshold
        }
        flagTypePolicies {
          flagType
          enabled
          priority
        }
        effectiveFlagPolicies {
          flagType
          enabled
          priority
          thresholdCents
          percentThreshold
          policySource
          policySourceOrganizationId
          thresholdSource
          thresholdSourceOrganizationId
        }
      }
    }
  }
`;

export const UPDATE_ORG_FLAG_POLICIES = gql`
  mutation updateOrgFlagPolicies($input: UpdateOrgFlagPolicyInput!) {
    updateOrgFlagPolicy(input: $input) {
      organization {
        id
        flagAmountThresholds {
          flagType
          thresholdCents
          percentThreshold
        }
        flagTypePolicies {
          flagType
          enabled
          priority
        }
        effectiveFlagPolicies {
          flagType
          enabled
          priority
          thresholdCents
          percentThreshold
          policySource
          policySourceOrganizationId
          thresholdSource
          thresholdSourceOrganizationId
        }
      }
    }
  }
`;
